/**
 * MessageStream — лента сообщений с auto-scroll вниз.
 *
 * Props:
 *   messages  — массив { id, role, content, sources? } (role: 'user' | 'assistant')
 *   sending   — boolean (показывает TypingDots внизу когда true)
 *   loading   — boolean (показывает <LoadingSlot /> вместо ленты пока true)
 *   loadingSlot — ReactNode (опц., свой spinner; по умолчанию ничего — пусто)
 *   emptySlot — ReactNode (опц., рендерится когда messages.length === 0 && !loading)
 *   collapsibleAssistant — boolean (опц.). Прокидывается в MessageBubble как
 *               collapsible — длинные ответы ассистента сворачиваются под
 *               «Подробнее» (стиль Gemini Daily Brief). По умолчанию выкл.
 *   children  — игнорируется (используем slots)
 *
 * Auto-scroll: при добавлении сообщения или старте typing — скроллим вниз.
 */

import { useEffect, useRef } from 'react'
import MessageBubble from './MessageBubble'
import TypingDots from './TypingDots'

export default function MessageStream({
    messages = [],
    sending = false,
    loading = false,
    loadingSlot = null,
    emptySlot = null,
    collapsibleAssistant = false,
    onSourceClick = null,
}) {
    const scrollerRef = useRef(null)

    useEffect(() => {
        const el = scrollerRef.current
        if (!el) return
        // Defer to next frame so newly appended bubble is in DOM.
        const id = requestAnimationFrame(() => {
            el.scrollTop = el.scrollHeight
        })
        return () => cancelAnimationFrame(id)
    }, [messages, sending])

    return (
        <div className="conversation__stream" ref={scrollerRef}>
            {loading ? (
                loadingSlot
            ) : messages.length === 0 ? (
                emptySlot
            ) : (
                messages.map((m) => (
                    <MessageBubble
                        key={m.id}
                        role={m.role}
                        content={m.content}
                        sources={m.sources}
                        collapsible={collapsibleAssistant}
                        onSourceClick={onSourceClick}
                    />
                ))
            )}
            {sending ? <TypingDots /> : null}
        </div>
    )
}
